setTimeout(function () {
  let nextBtn = document.querySelector('.form-next-btn');
  let backBtn = document.querySelector('.form-back-btn');
  let firstPart = document.querySelector('.form-topbar-btn-1');
  let lastPart = document.querySelector('.form-topbar-btn-2');
  let subfooter1 = document.querySelector('.form-subfooter-1');
  let subfooter2 = document.querySelector('.form-subfooter-2');
  let formWrapper = document.querySelector('.multistep-contact-form-inner .ck-form-root');


  if (nextBtn) nextBtn.addEventListener('click', next);
  if (lastPart) lastPart.addEventListener('click', next);
  if (backBtn) backBtn.addEventListener('click', back);
  if (firstPart) firstPart.addEventListener('click', back);

  function next() {

    if (!formWrapper) {
      formWrapper = document.querySelector('.multistep-contact-form-inner .ck-form-root');
    }
    
    const fieldContainers = formWrapper ? formWrapper.querySelectorAll('.ck-field') : [];
    let allValid = true;

    if (fieldContainers.length === 0) {
      console.error("No .ck-field elements found! The app might not have rendered them yet.");
      return;
    }


    for (let i = 0; i < 5; i++) {
      const container = fieldContainers[i];
      if (!container) continue;

      const inputs = container.querySelectorAll('input');
      let fieldGroupValid = false;

      inputs.forEach(input => {
        if (input.type === 'checkbox') {
          if (input.checked) fieldGroupValid = true;
        } else {
          if (input.value.trim() !== "") fieldGroupValid = true;
        }
      });

      if (!fieldGroupValid) {
        allValid = false;
        container.style.border = "1px solid red";
        container.style.padding = "10px";
      } else {
        container.style.border = "none";
        container.style.padding = "0";
      }
    }

    if (!allValid) {
      alert("Please fill out the required fields.");
      return;
    }


    firstPart.classList.remove('active');
    lastPart.classList.add('active');
    subfooter1.classList.remove('active');
    subfooter2.classList.add('active');
    formWrapper.classList.add('second-part-visible');
  }

  function back() {
    firstPart.classList.add('active');
    lastPart.classList.remove('active');
    subfooter1.classList.add('active');
    subfooter2.classList.remove('active');
    if (formWrapper) formWrapper.classList.remove('second-part-visible');
  }
}, 1000);